import { render, staticRenderFns } from "./groupSkillParams.vue?vue&type=template&id=1a3670b1&scoped=true&"
import script from "./groupSkillParams.vue?vue&type=script&lang=js&"
export * from "./groupSkillParams.vue?vue&type=script&lang=js&"
import style0 from "./groupSkillParams.vue?vue&type=style&index=0&id=1a3670b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3670b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3670b1')) {
      api.createRecord('1a3670b1', component.options)
    } else {
      api.reload('1a3670b1', component.options)
    }
    module.hot.accept("./groupSkillParams.vue?vue&type=template&id=1a3670b1&scoped=true&", function () {
      api.rerender('1a3670b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/skill/groupSkillParams.vue"
export default component.exports